var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgWarningIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99988 6.49995V9.83328M9.99988 13.1666H10.0082M8.84598 2.24305L1.9919 14.0819C1.61173 14.7386 1.42165 15.0669 1.44974 15.3364C1.47425 15.5714 1.59739 15.785 1.78852 15.924C2.00765 16.0833 2.38704 16.0833 3.14581 16.0833H16.8539C17.6127 16.0833 17.9921 16.0833 18.2112 15.924C18.4024 15.785 18.5255 15.5714 18.55 15.3364C18.5781 15.0669 18.388 14.7386 18.0078 14.0819L11.1538 2.24305C10.775 1.58875 10.5856 1.26159 10.3385 1.15172C10.1229 1.05587 9.87684 1.05587 9.66129 1.15172C9.41419 1.26159 9.22478 1.58875 8.84598 2.24305Z",
    stroke: "#FF5D26",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarningIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/warning-icon.52b19f4f.svg";
export { ForwardRef as ReactComponent };